import type { UserProfile } from '@/shared/utils/format-status.js';

export type CanManageDevelopmentUser = { isGlobalAdmin: boolean; profile: UserProfile } | null | undefined;

export function resolveCanManageDevelopment(user: CanManageDevelopmentUser): boolean {
    return Boolean(user?.isGlobalAdmin || user?.profile === 'CF');
}
